<template>
  <div class="table">
    <div class="table-header">
      <p>Chân trang</p>
      <!-- <div>
        <input v-model="filterTerm" placeholder="Name"/>
        <button @click="addClick" class="add-new">+ Add New</button>
      </div> -->
    </div>

    <div class="table-section">
      <table>
        <thead>
          <tr>
            <th>STT</th>
            <th>Dòng 1</th>
            <th>Dòng 2</th>
            <th>Người cập nhật</th>
            <th>Ngôn ngữ</th>
            <th>Hành động</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(ctt, i) in paginatedData" :key="i">
            <td>{{ (currentPage - 1) * pageSize + i + 1 }}</td>
            <td>{{ ctt.firstRow }}</td>
            <td>{{ ctt.secondRow }}</td>
            <td>{{ ctt.author }}</td>
            <td>{{ ctt.lang }}</td>
            <td>
              <div class="action-holder">
                <button style="background-color: #0298cf;" @click="editClick(ctt)"
                  v-if="$checkPermission('edit_footer')"><i class="fa-solid fa-pen-to-square"></i></button>
                <!-- <button style="background-color: #f80000;" @click="toggleAlert(ctt.id)"
                  v-if="$checkPermission('delete_footer')"><i class="fa-solid fa-trash"></i></button> -->
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <div @click="changePage(currentPage - 1)" :disabled="currentPage === 1"><i class="fa-solid fa-angle-left"></i></div>
      <div @click="changePage(1)" v-if="currentPage !== 1">1</div>
      <div v-if="currentPage - 2 >= 1" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
      <div style="color: #0298cf; background: rgba(171, 171, 171, 0.2);">{{ currentPage }}</div>
      <div v-if="currentPage + 2 <= totalPages" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
      <div @click="changePage(totalPages)" v-if="currentPage !== totalPages">{{ totalPages }}</div>
      <div @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages"><i class="fa-solid fa-angle-right"></i></div>
    </div>
  </div>

  <!-- Modal -->
  <base-modal :modalActive="modalActive" :modalTitle="modalTitle" @close="toggleModal">
    <div class="data-display">
      <div class="box"> <p>Dòng 1</p> </div>
      <textarea type="text" v-model="firstRow"></textarea>
    </div>

    <div class="data-display">
      <div class="box"> <p>Dòng 2</p> </div>
      <textarea type="text" v-model="secondRow"></textarea>
    </div>

    <!-- <div class="data-display">
      <div class="box"> <p>Ngôn ngữ</p> </div>
      <select v-model="lang">
        <option value="vn">vn</option>
        <option value="en">en</option>
      </select>
    </div> -->

    <div class="btn-container">
      <button type="button" v-if="id === 0" @click="createClick()">Tạo</button>
      <button type="button" v-if="id !== 0" @click="updateClick()">Cập nhật</button>
    </div>
  </base-modal>

  <alert-modal :modalActive="modalAlert" @close="toggleAlert(selectedId)"
    @delete="deleteClick(selectedId)"></alert-modal>
</template>
<script>
export default {
  data () {
    return {
      pageSize: 10,
      currentPage: 1,
      isValid: true,
      modalActive: false,
      modalAlert: false,
      modalTitle: '',
      filterTerm: '',
      selectedId: 0,
      isLoading: false,
      message: '',
      // data
      id: 0,
      firstRow: '',
      secondRow: '',
      lang: '',
      propertiesToCheck: ['firstRow', 'secondRow']
    }
  },
  computed: {
    getFooters () {
      return this.$store.getters['footer/backendFooters']
    },
    filterItems () {
      if (!this.filterTerm) {
        return this.getFooters
      }
      this.reloadPageWithFilter()
      const searchTerm = this.filterTerm.toLowerCase()
      return this.getFooters.filter(data =>
        data.companyName.toLowerCase().includes(searchTerm)
      )
    },
    paginatedData () {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.filterItems.slice(start, end)
    },
    totalPages () {
      const tp = Math.ceil(this.filterItems.length / this.pageSize)
      if (tp === 0) return 1
      return tp
    }
  },
  methods: {
    changePage (page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page
      }
    },
    reloadPageWithFilter () {
      this.currentPage = 1
    },
    toggleModal () {
      this.modalActive = !this.modalActive
    },
    toggleAlert (id) {
      this.selectedId = id
      this.modalAlert = !this.modalAlert
    },
    async getFooterData () {
      this.isLoading = true
      await this.$store.dispatch('footer/getFooterData')
      this.isLoading = false
    },
    addClick () {
      this.modalTitle = 'Tạo chân trang'
      this.id = 0
      this.companyName = ''
      this.address = ''
      this.phoneNumber = ''
      this.fax = ''
      this.lang = 'vn'
      this.toggleModal()
    },
    validateVariable () {
      this.isValid = true
      this.propertiesToCheck.forEach(key => {
        if (this[key] === '') {
          this.isValid = false
        }
      })
    },
    // async createClick () {
    //   this.validateVariable()
    //   if (!this.isValid) {
    //     this.$showError('Thiếu thông tin cần thiết!')
    //     return
    //   }
    //   const newFooter = {
    //     companyName: this.companyName,
    //     address: this.address,
    //     phoneNumber: this.phoneNumber,
    //     fax: this.fax,
    //     lang: this.lang
    //   }
    //   await this.$store.dispatch('footer/postFooter', newFooter)
    //   this.getFooterData()
    //   this.toggleModal()
    // },
    editClick (data) {
      this.toggleModal()
      this.isValid = true
      this.modalTitle = 'Chỉnh sửa chân trang'
      this.id = data.id
      this.firstRow = data.firstRow
      this.secondRow = data.secondRow
      this.lang = data.lang
    },
    async updateClick () {
      this.validateVariable()
      if (!this.isValid) {
        this.$showError('Thiếu thông tin cần thiết!')
        return
      }
      const updatedFooter = {
        id: this.id,
        firstRow: this.firstRow,
        secondRow: this.secondRow,
        lang: this.lang
      }
      await this.$store.dispatch('footer/updateFooter', updatedFooter)
      this.getFooterData()
      this.toggleModal()
    }
    // async deleteClick (id) {
    //   await this.$store.dispatch('footer/deleteFooter', id)
    //   const start = (this.currentPage - 1) * this.pageSize
    //   const end = start + this.pageSize
    //   if (this.filterItems.slice(start, end).length === 1 && this.currentPage > 1) {
    //     this.currentPage--
    //   }
    //   this.toggleAlert()
    //   this.getFooterData()
    // }
  },
  created () {
    this.getFooterData()
  }
}
</script>
<style scoped>
  .table {
    width: 100%;
  }

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px;
    background-color: rgb(240, 240, 240);
    flex-wrap: wrap;
  }

  .table-header p {
    color: #000;
  }

  button {
    outline: none;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    padding: 10px;
    color: #fff;
  }

  .add-new {
    padding: 10px 20px;
    color: #fff;
    background-color: #0298cf;
  }

  .table-header input {
    padding: 10px 20px;
    margin: 0 10px;
    outline: none;
    border: 1px solid #0298cf;
    border-radius: 6px;
    color: #0298cf;
  }

  ::placeholder {
    color: #0298cf;
  }

  /* table-header end */

  .table-section {
    min-height: 590px;
  }

  table {
    width: 100%;
    table-layout: auto;
    min-width: 1000px;
    border-collapse: collapse;
  }

  thead th {
    position: sticky;
    top: 0;
    background-color: #0298cf;
    color: #fff;
    font-size: 15px;
    height: 50px;
  }

  th,td {
    border-bottom: 1px solid #dddddd;
    padding: 10px 20px;
    text-align: center;
    border-right: 1px solid #dddddd;
    border-left: 1px solid #dddddd;
  }

  td {
    text-align: left;
  }

  tr:hover td {
    background-color: #cfe2ff;
  }

  .action-holder {
    display: flex;
    justify-content: space-around;
  }

  ::-webkit-scrollbar{
    height: 5px;
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3)
  }

  ::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3)
  }

  tr:nth-child(even) {background-color: #ececec }

  th:nth-child(1), td:nth-child(1) {
    text-align: center;
    width: 60px;
  }

  th:nth-child(8), td:nth-child(8) {
    text-align: center;
    width: 120px;
  }

  td:nth-child(4), td:nth-child(5), td:nth-child(6), td:nth-child(7) {
    text-align: center;
  }

  /* table end */

  .pagination {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding: 20px 20px;
  }

  .pagination div{
    padding: 10px;
    border: 1px solid #d5d0d0;
    height: 40px;
    width: 40px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0298cf;
    color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.75);
    margin: 0 5px;
    cursor: pointer;
  }

  /* modal */

  .data-display {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    /* border: 2px solid #000; */
  }

  .data-display .box {
    width: 120px;
  }

  .data-display input {
    height: 40px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 10px;
  }

  .data-display textarea{
    height: 80px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 5px 10px;
  }

  .btn-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 30px;
  }

  .btn-container button {
    padding: 12px 30px;
    color: #fff;
    background-color: #0298cf;
  }

  .errors {
    font-weight: bold;
    color: red;
  }

  .data-display select {
    height: 40px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 7px;
  }
</style>
